import script from "./DocumentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentDialog.vue?vue&type=style&index=0&id=4ef051ae&scoped=true&lang=css"
import "./DocumentDialog.vue?vue&type=style&index=1&id=4ef051ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef051ae"]])

export default __exports__